import { LayoutAdministrare } from "@/components/administrare/LayoutAdministrare";

export default function AdministrareConfigurare() {
  return (
    <LayoutAdministrare
      titlu="Configurare"
      descriere={
        <>
          Regruparea parametrilor de configurare ai targetării: mapările CAEN,
          scorurile, regulile de clasificare și sursele de liste rămân unde erau
          (Targetare NIS2); aici sunt doar link-urile către ele, plus o pagină
          nouă de Setări pentru cheile simple din{" "}
          <code className="font-mono">targetare.setare</code>.
        </>
      }
    />
  );
}
